<nav class="navbar navbar-dark bg-dark card-bg-7">

    <div class="navbar-expand mr-auto">
        <div class="navbar-nav">

            <div class="text-left p-1">

                <a class="navbar-brand" [routerLink]="'/admin/dashboard'">
                    <img src="assets/logo_color.png" class="img-fluid" style="    max-width: 230px;
    padding-left: 8px;"/>
                </a>
                <label style="color: #ffffff45;font-size: 10px;margin-left:50px;" class="ml-6">
                </label>
            </div>


            <button appHasPermission hasPermission="view_dashboard" mat-button [routerLink]="'/admin/dashboard'">
                Dashboard
            </button>


<!--            <button appHasPermission hasPermission="view_reports" [routerLink]="'/system/reports'" mat-button>Reports-->
<!--            </button>-->



        </div>
    </div>

    <div class="navbar-expand ml-auto navbar-nav">
        <div class="navbar-nav">

            <!--massages-->

            <h6 style="color: white;padding-top: 10px;padding-right: 10px;">Welcome {{user?.name}}</h6>

            <button mat-icon-button [matMenuTriggerFor]="menu">
                <i class="fa fa-ellipsis-v"></i>
            </button>

            <mat-menu #menu="matMenu">

                <button routerLink="/admin/agent-details" mat-menu-item>
                    <!--  <i class="fa fa-user"></i>-->
                    <span>My profile</span>
                </button>
                <button (click)="onLogout()" mat-menu-item>
                    <!-- <i class="fa fa-send"></i>-->
                    <span>Logout</span>
                </button>
            </mat-menu>



        </div>
    </div>
</nav>

